import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable({
  providedIn: 'root'
})
export class ExportExcelServiceService {

  public exportAsExcelFile(json: any[], excelFileName: string, simple?: boolean): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName, simple);
  }
  private saveAsExcelFile(buffer: any, fileName: string, simple?: boolean): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    const fileNameString: string = fileName + simple ? '' : '_export_' + new Date().getTime();
    FileSaver.saveAs(data, fileName + fileNameString + EXCEL_EXTENSION);
  }
}